import React from 'react'

import { ExtendedLink } from '@app/components'

import { REGISTRY_PAGE } from '@app/constants/page'

import { Show } from '@app/components/util'

import styles from '../styles.module.scss'

import type { DescriptionSectionProps } from './types'

export const DescriptionSection: React.FC<DescriptionSectionProps> = ({ dataSource }) => {
  const monitoringId = dataSource?.monitoringId

  const linkToRegistryPageInner: React.ReactNode = monitoringId && (
    <ExtendedLink
      to={ `${REGISTRY_PAGE.registry}/${monitoringId}` }
      target='_blank'
    >
      Ссылка
    </ExtendedLink>
  )

  return (
    <div className={ styles.internalTaskSection }>
      <h5 className={ styles.internalTaskSection__title }>Описание задачи</h5>

      <Show condition={ !!monitoringId }>
        <div className={ styles.internalTaskSection__row }>{ linkToRegistryPageInner }</div>
      </Show>
      <div className={ styles.internalTaskSection__row }>
        <span className={ styles.internalTaskSection__rowTitle }>Количество строк, представленных к изменению:</span>
        <span>{ dataSource?.toChangeCount }</span>
      </div>
      <div className={ styles.internalTaskSection__row }>
        <span className={ styles.internalTaskSection__rowTitle }>Количество строк, представленных к удалению:</span>
        <span>{ dataSource?.toDeleteCount }</span>
      </div>
      <div className={ styles.internalTaskSection__row }>
        <span className={ styles.internalTaskSection__rowTitle }>Количество строк, представленных к добавлению:</span>
        <span>{ dataSource?.toAddCount }</span>
      </div>
    </div>
  )
}
